import React from "react";
import _ from "lodash";
import Select from "react-select";
import ItemsFilter from "components/ops-mgmt/common/ItemsFilter";
import SimpleTooltip from "components/common/SimpleTooltip";
import ModalWrapper from "components/common/ModalWrapper";
import ClickToCopyWrapper from "components/common/ClickToCopyWrapper";

import { FiInfo } from "react-icons/fi";

const codeStyle =
  "font-mono text-sm font-semibold text-gray-600 rounded p-1 bg-gray-200";

class FilterControl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenModal: false,
    };

    this.searchRef = React.createRef();
    this.handleSearch = this.handleSearch.bind(this);
  }

  handleSearch(value) {
    if (value === undefined) {
      if (this.searchRef.current) {
        const inputValue = this.searchRef.current.state.inputValue;
        this.props.handleSearch(inputValue);
      }
    } else {
      this.props.handleSearch(value);
    }
  }

  render() {
    const { tags, alias, dateDisabled = false } = this.props;
    const { isOpenModal } = this.state;

    const tagList = dateDisabled
      ? tags
      : [
          {
            value: "date",
            label: "Date",
            type: "string",
          },
          ...tags,
        ];
    const parseTags = tagList.filter(
      (tag) => !tag.hide || tag.type === "string"
    );

    const condition =
      parseTags.length > 0
        ? new Array(3).fill("").map((_) => {
            const rIdx = Math.floor(Math.random() * parseTags.length);
            const rTag = parseTags[rIdx];
            const rNum = rTag.label.includes("#")
              ? Math.floor(Math.random() * 10000) + 10000
              : Math.floor(Math.random() * 100) / 100;

            const rOpt = Math.random() < 0.5 ? ">" : "<";
            return `${rTag.value} ${rOpt} ${rNum}`;
          })
        : [];
    const sample =
      parseTags.length > 0
        ? [
            condition[0],
            `${condition[1]} ${Math.random() < 0.5 ? "AND" : "OR"} ${
              condition[2]
            }`,
          ]
        : [];

    return (
      <>
        <div className="flex gap-1">
          <div className="text-xs text-gray-600">Filter GAM Unit by</div>
          <SimpleTooltip
            tooltipText="Click to see how to perform data filtering using specific attributes."
            place="right"
          >
            <div
              className="flex cursor-pointer items-center text-blue-600"
              onClick={() => {
                this.setState({
                  isOpenModal: true,
                });
              }}
            >
              <FiInfo></FiInfo>
            </div>
          </SimpleTooltip>
        </div>

        <div className="mb-1 flex flex-wrap gap-2 text-xs">
          {parseTags.map((tag) => (
            <div
              key={tag.value}
              className={`rounded border cursor-pointer px-1 text-center ${
                tag.type === "string"
                  ? "text-blue-700 hover:bg-blue-200"
                  : "text-orange-700 hover:bg-orange-200"
              }`}
              style={{ minWidth: "1.5rem" }}
              onClick={() => {
                if (this.searchRef.current) {
                  this.searchRef.current.insertInputValue(tag.value, -1);
                }
              }}
            >
              {tag.group ? `${tag.group} ` : ""}
              {tag.label}
            </div>
          ))}
          {["==", "!=", ">", "<", ">=", "<="].map((value) => {
            return (
              <div
                key={value}
                className="rounded border cursor-pointer px-1 text-center font-semibold text-teal-700 hover:bg-teal-200"
                style={{ minWidth: "1.5rem" }}
                onClick={() => {
                  this.searchRef.current.insertInputValue(value);
                }}
              >
                {value}
              </div>
            );
          })}
          {["EQUALS", "CONTAINS"].map((value) => {
            return (
              <div
                key={value}
                className="rounded border cursor-pointer px-2 text-center text-gray-700 hover:bg-gray-300"
                style={{ minWidth: "1.5rem" }}
                onClick={() => {
                  if (this.searchRef.current) {
                    let inputValue = "";
                    if (value === "EQUALS") {
                      inputValue = `EQUALS ""`;
                    }
                    if (value === "CONTAINS") {
                      inputValue = `CONTAINS ""`;
                    }
                    this.searchRef.current.insertInputValue(
                      inputValue,
                      inputValue.length - 1,
                      false
                    );
                  }
                }}
              >
                {value}
              </div>
            );
          })}
          {["AND", "OR"].map((value) => {
            return (
              <div
                key={value}
                className="rounded border cursor-pointer px-1 text-center font-semibold text-purple-700 hover:bg-purple-200"
                style={{ minWidth: "1.5rem" }}
                onClick={() => {
                  this.searchRef.current.insertInputValue(value);
                }}
              >
                {value}
              </div>
            );
          })}
        </div>

        <div className="text-sm">
          <ItemsFilter
            ref={this.searchRef}
            isTextArea={true}
            placeholder="Use AND, OR, ==, >, < to build your search conditions."
            handleSearch={this.handleSearch}
          ></ItemsFilter>
        </div>

        {alias && alias.length > 0 && (
          <div className="bg-gray-200 p-1">
            <div className="divide-x mb-1 flex flex-wrap gap-1 text-xs">
              {_.orderBy(alias, "func", "desc").map((item, idx) => (
                <div
                  className={`${idx > 0 ? "pl-1" : ""} border-gray-400`}
                  key={idx}
                >
                  {item.func ? (
                    <FunctionTag
                      label={item.label}
                      func={item.func}
                      type={item.type}
                      options={item.options}
                      onClick={(val) => {
                        if (this.searchRef.current) {
                          this.searchRef.current.insertInputValue(val, -1);
                        }
                      }}
                    ></FunctionTag>
                  ) : (
                    <div
                      key={item.value}
                      className={`rounded border flex cursor-pointer items-center bg-white text-center text-blue-700 hover:bg-blue-200`}
                      style={{ minWidth: "1.5rem", padding: "0.2rem 0.25rem" }}
                      onClick={() => {
                        if (this.searchRef.current) {
                          this.searchRef.current.insertInputValue(
                            item.value,
                            -1
                          );
                        }
                      }}
                    >
                      {item.label}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {isOpenModal && (
          <ModalWrapper
            isOpen={true}
            showCloseFooter={true}
            customOverlayStyle={{ zIndex: 100 }}
            handleClose={() => {
              this.setState({
                isOpenModal: false,
              });
            }}
            title="Using Specific Attribute for Advanced Search"
          >
            <div className="mt-2  font-semibold text-gray-800">
              Support Attribute
            </div>
            <ul
              className="list-disc overflow-y-auto pl-8"
              style={{ maxHeight: "260px" }}
            >
              {parseTags.map((tag) => (
                <li key={tag.value}>
                  <span className={codeStyle}>
                    {tag.group ? `${tag.group} ` : ""}
                    {tag.label} = {tag.value}
                  </span>
                </li>
              ))}
            </ul>

            <div className="mt-2 font-semibold text-gray-800">
              Conditional Search
            </div>
            <ul className="list-disc pl-8">
              {["==", ">", "<", ">=", "<="].map((tag) => (
                <li key={tag}>
                  <span className={codeStyle}>{tag}</span>
                </li>
              ))}
            </ul>

            <div className="mt-2 font-semibold text-gray-800">
              Logical Operators
            </div>
            <ul className="list-disc pl-8">
              {["AND", "OR"].map((tag) => (
                <li key={tag}>
                  <span className={codeStyle}>{tag}</span>
                </li>
              ))}
            </ul>

            <div className="mt-2 font-semibold text-gray-800">
              Advanced Examples
            </div>
            <ul className="mb-2 list-disc pl-8">
              {sample.map((sample, idx) => (
                <li key={idx}>
                  <div className="flex items-center">
                    <span className={codeStyle}>{sample}</span>
                    <div className="text-blue-600">
                      <ClickToCopyWrapper
                        copyText={sample}
                      ></ClickToCopyWrapper>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </ModalWrapper>
        )}
      </>
    );
  }
}

class FunctionTag extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: _.get(props, "options[0]"),
    };

    this.customRef = React.createRef();
  }

  render() {
    const { func, label, onClick, type = "input", options } = this.props;
    const { selected } = this.state;

    return (
      <div className="flex items-center gap-1">
        <div
          className="rounded border flex cursor-pointer items-center gap-1 bg-white text-center text-blue-700 hover:bg-blue-200"
          style={{ minWidth: "1.5rem", padding: "0.2rem 0.25rem" }}
          onClick={() => {
            if (type === "input" && this.customRef.current) {
              const inputValue = this.customRef.current.value;
              onClick(func(_.toNumber(inputValue)));
            } else if (type === "select" && !_.isNil(selected)) {
              const selectedValue = _.get(selected, "value", "");
              onClick(func(selectedValue));
            }
          }}
        >
          <div>{label}</div>
        </div>
        {type === "select" && !_.isNil(options) ? (
          <Select
            className="w-40"
            isSearchable={false}
            options={options}
            value={selected}
            onChange={(selectedOption) => {
              this.setState({
                selected: selectedOption,
              });
            }}
            styles={{
              control: (provided) => ({
                ...provided,
                minHeight: "30px",
                height: "30px",
              }),
              valueContainer: (provided) => ({
                ...provided,
                height: "30px",
                padding: "0 6px",
              }),
              indicatorsContainer: (provided) => ({
                ...provided,
                height: "30px",
              }),
            }}
          ></Select>
        ) : (
          <input
            ref={this.customRef}
            type="number"
            className="border rounded focus:outline-none flex w-16 appearance-none bg-white p-1 leading-3 hover:border-gray-400 focus:border-blue-400 focus:shadow-inner"
            onClick={(e) => {
              e.stopPropagation();
            }}
          ></input>
        )}
      </div>
    );
  }
}

export default FilterControl;
